<div class="container-fluid">
  <div class="d-flex flex-column flex-sm-row">
    <mat-form-field>
      <mat-icon matPrefix color="primary">search</mat-icon>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Rechercher" />
    </mat-form-field>
    <mat-form-field class="ms-sm-3">
      <mat-label>Roles</mat-label>
      <mat-select [(value)]="filterRole" (valueChange)="updateDataFromFilters()">
        <mat-option>Tous</mat-option>
        <mat-option *ngFor="let role of availableRoles" [value]="role">{{rolesDisplay[role]}}</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="d-flex flex-fill justify-content-between">
      <mat-slide-toggle (change)="toggleDisplayColumns()" [checked]="displayFullColumns" class="m-3">Afficher toutes
        colonnes</mat-slide-toggle>
      <button mat-mini-fab appTooltip="Ajouter un utilisateur" class="ml-auto m-3 white" color="primary"
        (click)="add()">
        <mat-icon aria-label="Ajouter un utilisateur">add</mat-icon>
      </button>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="table-container">
    <div class="loading" *ngIf="isLoadingResults">
      <mat-spinner color="primary"></mat-spinner>
    </div>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
        <td mat-cell *matCellDef="let row" class="main mobile-inline name">{{ row.name }}</td>
      </ng-container>
      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef>Prénom</th>
        <td mat-cell *matCellDef="let row" class="main name">{{ row.firstName }}</td>
      </ng-container>
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
        <td mat-cell *matCellDef="let row" class="main">{{ row.email }}</td>
      </ng-container>
      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef>Rôle</th>
        <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.role }}</td>
      </ng-container>
      <ng-container matColumnDef="accountType">
        <th mat-header-cell *matHeaderCellDef>Type de compte</th>
        <td mat-cell *matCellDef="let row">{{ row.accountType }}</td>
      </ng-container>
      <ng-container matColumnDef="phoneNumber">
        <th mat-header-cell *matHeaderCellDef>Téléphone</th>
        <td mat-cell *matCellDef="let row" class="no-mobile">{{ row.uphoneNumber }}</td>
      </ng-container>
      <ng-container matColumnDef="company">
        <th mat-header-cell *matHeaderCellDef>Entreprise</th>
        <td mat-cell *matCellDef="let row" class="no-mobile">{{ row.company }}</td>
      </ng-container>
      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef>Activation</th>
        <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.user.active ? 'Activé' :
          'Désactivé' }}</td>
      </ng-container>
      <ng-container matColumnDef="lastConnectionDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Dernière connexion</th>
        <td mat-cell *matCellDef="let row">{{ row.user.lastConnectionDate | dateTimeFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="emailValidated">
        <th mat-header-cell *matHeaderCellDef>Email validé ?</th>
        <td mat-cell *matCellDef="let row" class="no-mobile">{{ row.user.emailValidated | booleanFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="dateCreate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date création</th>
        <td mat-cell *matCellDef="let row" class="no-mobile">{{ row.user.dateCreate | dateTimeFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="dateUpdate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date mise à jour</th>
        <td mat-cell *matCellDef="let row" class="no-mobile">{{ row.user.dateUpdate | dateTimeFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="uid">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let row">{{ row.uid }}</td>
      </ng-container>
      <ng-container matColumnDef="externalId">
        <th mat-header-cell *matHeaderCellDef>External ID</th>
        <td mat-cell *matCellDef="let row" class="no-mobile">{{ row.user.externalId }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row" class="mobile-double-actions">
          <button mat-icon-button [style]="row.isManagedExternally ? '' : 'visibility: hidden'"
            appTooltip="Cet utilisateur est géré de manière externe">
            <mat-icon color="accent">info</mat-icon>
          </button>
          <button mat-icon-button [matMenuTriggerFor]="actions" [matMenuTriggerData]="{data:row}">
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator [length]="paging.length" [pageSize]="paging.pagingPageSize"
      [pageSizeOptions]="paging.pagingPageSizeOptions" showFirstLastButtons></mat-paginator>
  </div>
</div>

<mat-menu #actions="matMenu">
  <ng-template matMenuContent let-row="data">
    <ul class="menu-actions">
      <li *ngIf="!row.isManagedExternally && !row.isAccountTypePremium">
        <a (click)="confirmUpgradeUserToPremium(row.user)"><mat-icon color="primary">vertical_align_top</mat-icon><span
            class="text">Passer en mode PREMIUM</span></a>
      </li>
      <li *ngIf="!row.isManagedExternally && !row.isRolePremiumOnly && row.isAccountTypePremium">
        <a (click)="confirmDowngradeUserToFree(row.user)"><mat-icon
            color="primary">vertical_align_bottom</mat-icon><span class="text">Rétrograder en mode FREE</span></a>
      </li>
      <li *ngIf="row.user.active">
        <a (click)="confirmDeActivateUser(row.user)"><mat-icon color="primary">block</mat-icon><span
            class="text">Désactiver l'utilisateur</span></a>
      </li>
      <li *ngIf="!row.user.active">
        <a (click)="confirmActivateUser(row.user)"><mat-icon color="primary">check</mat-icon><span class="text">Activer
            l'utilisateur</span></a>
      </li>
      <li *ngIf="!row.isManagedExternally">
        <a (click)="confirmResetUserPassword(row.user)"><mat-icon color="primary">lock_open</mat-icon><span
            class="text">Réinitialiser le mot de passe</span></a>
      </li>
      <li *ngIf="!row.isManagedExternally && !row.user.emailValidated">
        <a (click)="confirmSendValidationMail(row.user)"><mat-icon color="primary">mail_outline</mat-icon><span
            class="text">Envoyer le mail de validation</span></a>
      </li>
      <li *ngIf="!row.isManagedExternally">
        <a (click)="edit(row.user)"><mat-icon color="primary">create</mat-icon><span class="text">Modifier
            l'utilisateur</span></a>
      </li>
      <li *ngIf="!row.isAdmin">
        <a (click)="confirmAssumeUser(row.user)"><mat-icon color="primary">fingerprint</mat-icon><span
            class="text">Ouvrir une
            session</span></a>
      </li>
      <li>
        <a (click)="confirmDelete(row.user)">
          <mat-icon color="primary">delete_forever</mat-icon>
          <span class="text">Supprimer l'utilisateur</span>
        </a>
      </li>
    </ul>
  </ng-template>
</mat-menu>